<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <!-- Header -->
    <div class="s-modal__header s-modal__header--transparent">
      <button id="s-modal-close"
              type="button"
              class="s-modal__btn--close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <!-- Main Content -->
    <div class="s-modal__body s-modal__body--start">
      <div class="s-modal__body s-modal__body--success">
        <div class="s-modal__label s-modal__label--etc">{{data.title}}</div>
        <div class="s-modal-content--etc" v-html="data.text"></div>

        <div class="s-modal__btn__wrap">
          <button class="s-modal__btn--ws red s-modal__btn--ws--options"
                  @click="cancel">{{data.cancelText}}</button>
          <button class="s-modal__btn--ws blue s-modal__btn--ws--options"
                  @click="confirm">{{data.confirmText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalEtcTemplate',
      props : {
        data: {
          type: Object,
          default: function () {
            return {
              title: '미션 초기화',
              text: '미션을 최초 상태로 되돌리시겠습니까?<br/>' +
                '* 사용한 블록이 모두 초기화 됩니다.',
              cancelText: '아니오',
              confirmText: '예'
            }
          }
        }
      },
      methods: {
        cancel() {
          this.$emit('cancel', () => {})
        },
        confirm() {
          this.$emit('confirm', function () {
            this.$refs.gamecanvas.restartCanvas()
            this.$refs.workspace.initStartBlock()
          })
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialEtc.vue